import { render, staticRenderFns } from "./AppCloseAccount.vue?vue&type=template&id=b4a5ea7a&scoped=true&"
import script from "./AppCloseAccount.vue?vue&type=script&lang=js&"
export * from "./AppCloseAccount.vue?vue&type=script&lang=js&"
import style0 from "./AppCloseAccount.vue?vue&type=style&index=0&id=b4a5ea7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a5ea7a",
  null
  
)

export default component.exports